interface Props {
  sortOption: string;
  setSortOption: React.Dispatch<React.SetStateAction<string>>;
  options: { value: string; label: string }[]; // ← 追加
}

const SortSelect: React.FC<Props> = ({
  sortOption,
  setSortOption,
  options,
}) => (
  <div className="sort-select">
    <label>並び替え：</label>
    <select value={sortOption} onChange={(e) => setSortOption(e.target.value)}>
      {options.map((opt) => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
  </div>
);

export default SortSelect;
